import {
    OBTENER_MARCAS,
    AGREGAR_MARCA,
    ELIMINAR_MARCA,
    ACTUALIZAR_MARCA,
    MARCA_ERROR,
    MARCA_OK,
    MARCA_ACTUAL,
    OBTENER_MARCA,
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_MARCAS:
            return {
                ...state,
                marcas: action.payload
            }
        case MARCA_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case MARCA_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_MARCA:
            return {
                ...state,
                marca:action.payload,
                marcas: [...state.marcas, action.payload],
                formulario: false,
                errorformulario: false
            }
        case MARCA_ACTUAL:
            return {
                ...state,
                marca: state.marcas.find(marca => marca._id === action.payload)
            }
        case ELIMINAR_MARCA:
            return {
                ...state,
                marcas: state.marcas.filter(marca => marca._id !== action.payload),
                marca: null
            }
        case ACTUALIZAR_MARCA:
            return {
                ...state,
                marcas: state.marcas.map(marca => marca._id === action.payload._id ? action.payload : marca),
                marca: action.payload
            }
        case OBTENER_MARCA:
            return {
                ...state,
                marca: action.payload
            }
        default:
            return state;
    }
}